var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.62 113.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aabeeb61-3f92-4579-ac14-3713dddee607{fill:none;stroke:#89a6df;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eba327ec-85d9-4ad7-9ce2-4927c3368ce4",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aabeeb61-3f92-4579-ac14-3713dddee607",
    d: "M18.89,102.72,63.65,76.23a3.67,3.67,0,0,0,1.79-3.15V65.5l0-28a3.64,3.64,0,0,1,1.92-3.23l40.42-23.64"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.e551e9f0.svg";
export { ForwardRef as ReactComponent };